import React, { useEffect, useState } from "react";
import {
    TextField,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    useTheme,
    MenuItem,
    Box,
    IconButton,
    FormControlLabel,
    Checkbox,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { add } from "dayjs";
import DeleteIcon from "@mui/icons-material/Delete";
import {
    addContract,
    updateContract,
    getVacantUnits,
    deleteContractDoc,
    getContractDoc,
    getContractPdc,
    deleteContractPdc,
} from "state/apis";
import { toast } from "react-toastify";
import Autocomplete from "@mui/material/Autocomplete";
import Receipt from "./Receipt";
import { Close as CloseIcon } from "@mui/icons-material";
import moment from "moment";

const AddContract = ({
    open,
    onClose,
    onSubmit,
    editData,
    editMode,
    property,
    tenants,
    banks,
    renewMode,
    isSold,
}) => {
    const theme = useTheme();
    const [units, setFlat] = useState([]);
    const [openReceipt, setOpenReceipt] = useState(false);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const defaultProperty = localStorage.getItem("propertyId");
    const [deleteItem, setDeleteItem] = React.useState(null);
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = React.useState(false);
    const [deleteConfirmationPdcOpen, setDeleteConfirmationPdcOpen] = React.useState(false);
    const [deletePdc, setDeletePdc] = React.useState(null);
    const [data, setData] = useState({
        propertyId: defaultProperty || "",
        unitId: "",
        tenantId: "",
        yearRent: "",
        totalYearsOfStay: "",
        contractFrom: "",
        contractTo: "",
        remarks: "",
        deposit: "",
        pdc: [],
        docs: [],
        closed: false,
        lastContractId: "",
    });
    const [attachment, setAttachment] = useState([]);
    const [pdc, setPdc] = useState([]);

    const fetchUnit = async (id, unitId) => {
        const res = await getVacantUnits(100, 0, "", id, unitId);
        setFlat(res.data);
    };

    const handleDeleteClick = (row) => {
        setDeleteItem(row?.id);
        setDeleteConfirmationOpen(true);
    };

    const handleDeleteConfirmation = async () => {
        try {
            await deleteContractDoc(deleteItem);
            toast.success("Contract doc deleted successfully.");
            const res = await getContractDoc(editData.id);
            setAttachment(res?.data);
            setDeleteConfirmationOpen(false);
        } catch (error) {
            console.error("Error deleting contract doc:", error);
            toast.error("Failed to delete contract doc. Please try again.");
        }
    };

    const handleDeletePdcClick = (row) => {
        console.log("row-->", row);
        setDeletePdc(row?.id);
        setDeleteConfirmationPdcOpen(true);
    };

    const handleDeleteConfirmationPdc = async () => {
        try {
            await deleteContractPdc(deletePdc);
            toast.success("Contract pdc deleted successfully.");
            const res = await getContractPdc(editData.id);
            setPdc(res?.data);
            setDeleteConfirmationPdcOpen(false);
        } catch (error) {
            console.error("Error deleting contract pdc:", error);
            toast.error("Failed to delete contract pdc. Please try again.");
        }
    };

    const handleDocumentOpen = (url) => {
        window.open(url, "_blank");
    };

    React.useEffect(() => {
        const fetchData = async () => {
            if (editMode && editData) {
                try {
                    const res = await getContractDoc(editData.id);
                    setAttachment(res?.data);
                } catch (error) {
                    console.error("Error fetching data:", error);
                }
            } else {
                setAttachment([]);
            }
        };

        const fetchPdcData = async () => {
            if (editMode && editData) {
                try {
                    const res = await getContractPdc(editData.id);
                    setPdc(res?.data);
                } catch (error) {
                    console.error("Error fetching data:", error);
                }
            } else {
                setPdc([]);
            }
        };

        fetchPdcData();

        fetchData();
    }, [editData, editMode]);

    useEffect(() => {
        if (editMode && editData && !renewMode) {
            fetchUnit(editData.propertyId, editData.unitId);
            setData((prevData) => ({
                ...prevData,
                propertyId: editData.propertyId,
                unitId: editData.unitId,
                tenantId: editData.tenantId,
                yearRent: editData.yearRent,
                totalYearsOfStay: editData.totalYearsOfStay,
                contractFrom: editData.contractFrom,
                contractTo: editData.contractTo,
                remarks: editData.remarks,
                deposit: editData.deposit,
                closed: editData.closed,
            }));
            // setAttachment(editData?.contractDocument);
            setFlat([]);
        } else if (!editMode && !renewMode) {
            setData({
                propertyId: defaultProperty || "",
                unitId: "",
                yearRent: "",
                tenantId: "",
                totalYearsOfStay: "",
                contractFrom: "",
                contractTo: "",
                remarks: "",
                deposit: "",
                pdc: [],
                docs: [],
                closed: false,
            });
            fetchUnit(defaultProperty);
            setAttachment([]);
        } else {
            fetchUnit(editData.propertyId, editData.unitId);
            setData((prevData) => ({
                ...prevData,
                propertyId: editData.propertyId,
                unitId: editData.unitId,
                tenantId: editData.tenantId,
                yearRent: editData.yearRent,
                totalYearsOfStay: editData?.totalYearsOfStay + 1 || 0,
                contractFrom: moment(editData?.contractTo).add(1, "days").format("YYYY-MM-DD"),
                contractTo: moment(editData?.contractTo).add(1, "year").format("YYYY-MM-DD"),
                remarks: "",
                deposit: editData?.deposit,
                closed: false,
                pdc: [],
                docs: [],
                lastContractId: editData?.id,
            }));
            // setAttachment(editData?.contractDocument);
            setFlat([]);
        }
    }, [editData, editMode, renewMode]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const handleChangeDate = (date) => {
        const formattedDate = date.format("YYYY-MM-DD");

        setData((prevData) => {
            let newContractTo = prevData.contractTo;
            if (!editMode || (editMode && renewMode)) {
                // Add one year to the contractFrom date
                newContractTo = date.add(1, "year").subtract(1, "day").format("YYYY-MM-DD");
            }

            return {
                ...prevData,
                contractFrom: formattedDate,
                contractTo: newContractTo,
            };
        });
    };
    const handleContractTo = (date) => {
        const data = date;
        const formattedDate = data.format("YYYY-MM-DD");

        setData((prevData) => ({
            ...prevData,
            contractTo: formattedDate,
        }));
    };
    const handlePropertyChange = (newValue) => {
        setData((prevData) => ({
            ...prevData,
            propertyId: newValue ? newValue.id : null,
        }));
        if (newValue !== null) {
            fetchUnit(newValue.id);
        }
        setFlat([]);
    };
    const handleUnitChange = (newValue) => {
        setData((prevData) => ({
            ...prevData,
            unitId: newValue ? newValue.id : null,
        }));
    };
    const handleTenantChange = (newValue) => {
        setData((prevData) => ({
            ...prevData,
            tenantId: newValue ? newValue.id : null,
        }));
    };
    const handleAddDocument = () => {
        setData((prevData) => ({
            ...prevData,
            docs: [...prevData.docs, { name: "", file: null }],
        }));
    };

    const handleDocumentNameChange = (index, value) => {
        const updatedDocuments = [...data.docs];
        updatedDocuments[index].name = value;
        setData((prevData) => ({
            ...prevData,
            docs: updatedDocuments,
        }));
    };
    const handleCancelDocument = (indexToRemove) => {
        setData((prevState) => ({
            ...prevState,
            docs: prevState.docs.filter((_, index) => index !== indexToRemove),
        }));
    };
    const handleDocumentFileChange = (index, file) => {
        const updatedDocuments = [...data.docs];
        updatedDocuments[index].file = file;
        setData((prevData) => ({
            ...prevData,
            docs: updatedDocuments,
        }));
    };

    const handlePdcChange = (index, key, value) => {
        setData((prevData) => {
            const updatedPdc = prevData.pdc.map((item, idx) => {
                if (idx === index && Object.keys(item).includes(key)) {
                    return {
                        ...item,
                        [key]: value,
                    };
                }
                return item;
            });

            return {
                ...prevData,
                pdc: updatedPdc,
            };
        });
    };
    const handleBankChange = (index, newValue) => {
        setData((prevData) => ({
            ...prevData,
            pdc: prevData.pdc.map((item, idx) => {
                if (idx === index) {
                    return {
                        ...item,
                        bank: newValue ? newValue.id : null,
                    };
                }
                return item;
            }),
        }));
    };

    const handleChangeChequeDate = (date, index) => {
        const formattedDate = date.format("YYYY-MM-DD");
        setData((prevData) => ({
            ...prevData,
            pdc: prevData.pdc.map((item, idx) => {
                if (idx === index) {
                    return {
                        ...item,
                        chequeDate: formattedDate,
                    };
                }
                return item;
            }),
        }));
    };

    const handleAddPdc = () => {
        setData((prevData) => ({
            ...prevData,
            pdc: [
                ...prevData.pdc,
                { chequeSerialNumber: "", chequeDate: "", bank: "", amount: "", type: "" },
            ],
        }));
    };
    const handleCancelPdc = (indexToRemove) => {
        setData((prevState) => ({
            ...prevState,
            pdc: prevState.pdc.filter((_, index) => index !== indexToRemove),
        }));
    };

    const handleSubmit = async () => {
        try {
            if (editMode && !renewMode) {
                const response = await updateContract(editData.id, data);
                toast.success(response.message);
                setFlat([]);
            } else {
                const response = await addContract(data);
                toast.success(response.message);
                setFlat([]);
            }

            onSubmit();
            onClose();
        } catch (error) {
            console.error("Error:", error);
            if (error.response) {
                toast.error(error.response.data.message);
            } else if (error.request) {
                toast.error("No response received from server.");
            } else {
                toast.error("An error occurred. Please try again.");
            }
        }
    };

    const handleOpenReceipt = async () => {
        setOpenReceipt(true);
        setSelectedRow(editData?.id);
    };

    const handleCloseReceipt = () => {
        setOpenReceipt(false);
    };

    return (
        <>
            <Dialog open={open} onClose={onClose} fullWidth maxWidth={"lg"}>
                <DialogTitle
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        fontWeight: "bold",
                        marginLeft: "6px",
                    }}
                >
                    {editMode
                        ? renewMode
                            ? "Renew Contract Registration"
                            : "Edit Contract Registration"
                        : "Add Contract Registration"}
                    <IconButton onClick={onClose} sx={{ color: "inherit" }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={3} p={"5px"}>
                        <Grid item xs={6}>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={property}
                                getOptionLabel={(option) => option.propertyName}
                                value={
                                    defaultProperty
                                        ? property.find((pro) => pro.id == defaultProperty) || null
                                        : null
                                }
                                onChange={(event, newValue) => handlePropertyChange(newValue)}
                                isOptionEqualToValue={(option, value) => option === value}
                                getOptionDisabled={(option) => option.id != defaultProperty}
                                renderOption={(props, option) => (
                                    <li {...props} key={option.id}>
                                        {option.propertyName}
                                    </li>
                                )}
                                sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused fieldset": {
                                            borderColor: "primary.main",
                                        },
                                    },
                                    "& .MuiInputLabel-root": {
                                        "&.Mui-focused": {
                                            color: "primary.main",
                                        },
                                    },
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} fullWidth label="Select Property" />
                                )}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Autocomplete
                                disablePortal
                                disabled={editMode}
                                id="combo-box-demo"
                                options={units}
                                getOptionLabel={(option) => option.unitNumber}
                                value={
                                    data.unitId
                                        ? units.find((unit) => unit.id === data.unitId)
                                        : null
                                }
                                onChange={(event, newValue) => handleUnitChange(newValue)}
                                isOptionEqualToValue={(option, value) => option === value}
                                renderOption={(props, option) => (
                                    <li {...props} key={option.id}>
                                        {option.unitNumber}
                                    </li>
                                )}
                                sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused fieldset": {
                                            borderColor: "primary.main",
                                        },
                                    },
                                    "& .MuiInputLabel-root": {
                                        "&.Mui-focused": {
                                            color: "primary.main",
                                        },
                                    },
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} fullWidth label="Select Unit" />
                                )}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Autocomplete
                                disablePortal
                                disabled={editMode}
                                id="combo-box-demo"
                                options={tenants}
                                getOptionLabel={(option) => option?.name}
                                value={
                                    data.tenantId
                                        ? tenants.find((val) => val.id === data.tenantId)
                                        : null
                                }
                                onChange={(event, newValue) => handleTenantChange(newValue)}
                                isOptionEqualToValue={(option, value) => option === value}
                                renderOption={(props, option) => (
                                    <li {...props} key={option.id}>
                                        {option.name}
                                    </li>
                                )}
                                sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused fieldset": {
                                            borderColor: "primary.main",
                                        },
                                    },
                                    "& .MuiInputLabel-root": {
                                        "&.Mui-focused": {
                                            color: "primary.main",
                                        },
                                    },
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} fullWidth label="Select Tenant" />
                                )}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <TextField
                                color="primary"
                                fullWidth
                                label="Yearly Rent"
                                name="yearRent"
                                value={data?.yearRent}
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <TextField
                                color="primary"
                                fullWidth
                                label="Deposit"
                                name="deposit"
                                type="number"
                                value={data?.deposit}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                color="primary"
                                fullWidth
                                label="Total Years Of Stay"
                                name="totalYearsOfStay"
                                type="number"
                                value={data?.totalYearsOfStay}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} color="primary">
                                <DatePicker
                                    fullWidth
                                    label="Select contract from "
                                    name="contractFrom"
                                    onChange={handleChangeDate}
                                    value={data.contractTo ? dayjs(data.contractFrom) : null}
                                    format="DD/MM/YYYY"
                                    sx={{
                                        width: "100%",
                                        "& .MuiOutlinedInput-root": {
                                            "&.Mui-focused fieldset": {
                                                borderColor: "primary.main",
                                            },
                                        },
                                        "& .MuiInputLabel-root": {
                                            "&.Mui-focused": {
                                                color: "primary.main",
                                            },
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={6}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} color="primary">
                                <DatePicker
                                    label="Select contract to "
                                    name="contractTo"
                                    value={data.contractTo ? dayjs(data.contractTo) : null}
                                    onChange={handleContractTo}
                                    format="DD/MM/YYYY"
                                    sx={{
                                        width: "100%",
                                        "& .MuiOutlinedInput-root": {
                                            "&.Mui-focused fieldset": {
                                                borderColor: "primary.main",
                                            },
                                        },
                                        "& .MuiInputLabel-root": {
                                            "&.Mui-focused": {
                                                color: "primary.main",
                                            },
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            m={3}
                            mb={1}
                            border={1}
                            borderRadius={1}
                            p={2}
                            mr={0}
                            sx={{ borderColor: "grey.400" }}
                        >
                            <Grid container alignItems="center" fullWidth>
                                <Grid item xs={10}>
                                    <label style={{ color: theme.palette.grey[600] }}>
                                        Property Documents
                                    </label>
                                </Grid>
                                <Grid item xs={2} container justifyContent="flex-end">
                                    <Button variant="contained" onClick={handleAddDocument}>
                                        Add Document
                                    </Button>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                {data?.docs.map((document, index) => (
                                    <Grid container spacing={2} key={index} p={1}>
                                        <Grid item xs={5}>
                                            <TextField
                                                fullWidth
                                                color="primary"
                                                label="Document Name"
                                                value={document.name}
                                                onChange={(e) =>
                                                    handleDocumentNameChange(index, e.target.value)
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={4} margin={"auto"}>
                                            <input
                                                type="file"
                                                accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                onChange={(e) =>
                                                    handleDocumentFileChange(
                                                        index,
                                                        e.target.files[0]
                                                    )
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={3} container justify="end" margin="auto">
                                            <IconButton
                                                color="error"
                                                onClick={() => handleCancelDocument(index)}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                ))}
                                {editMode && !renewMode && (
                                    <>
                                        <TableContainer
                                            sx={{
                                                overflowX: "auto",
                                                marginBottom: theme.spacing(2),
                                                maxHeight: 900,
                                            }}
                                        >
                                            <Table
                                                stickyHeader
                                                aria-label="sticky table"
                                                sx={{
                                                    backgroundColor: "#fff",
                                                }}
                                            >
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell
                                                            fontWeight="900"
                                                            sx={{
                                                                backgroundColor:
                                                                    theme.palette.background.alt,
                                                                color: "#1a2138",
                                                            }}
                                                        >
                                                            Sr No
                                                        </TableCell>
                                                        <TableCell
                                                            fontWeight="900"
                                                            sx={{
                                                                backgroundColor:
                                                                    theme.palette.background.alt,
                                                                color: "#1a2138",
                                                            }}
                                                        >
                                                            Doc name
                                                        </TableCell>
                                                        {!isSold && (
                                                            <TableCell
                                                                sx={{
                                                                    backgroundColor:
                                                                        theme.palette.background
                                                                            .alt,
                                                                    color: theme.palette
                                                                        .secondary[50],
                                                                }}
                                                            >
                                                                Action
                                                            </TableCell>
                                                        )}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {attachment.length ? (
                                                        attachment.map((row, index) => (
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                                key={row.id}
                                                            >
                                                                <TableCell>{index + 1}</TableCell>
                                                                <TableCell
                                                                    onClick={() =>
                                                                        handleDocumentOpen(row.url)
                                                                    }
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    {row.name}
                                                                </TableCell>
                                                                {!isSold && (
                                                                    <TableCell>
                                                                        <IconButton
                                                                            color="error"
                                                                            onClick={() =>
                                                                                handleDeleteClick(
                                                                                    row
                                                                                )
                                                                            }
                                                                        >
                                                                            <DeleteIcon />
                                                                        </IconButton>
                                                                    </TableCell>
                                                                )}
                                                            </TableRow>
                                                        ))
                                                    ) : (
                                                        <TableRow>
                                                            <TableCell
                                                                colSpan={3}
                                                                sx={{
                                                                    textAlign: "center",
                                                                    fontWeight: "700",
                                                                    mb: "2px",
                                                                }}
                                                            >
                                                                No data found
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        <Dialog
                                            open={deleteConfirmationOpen}
                                            onClose={() => setDeleteConfirmationOpen(false)}
                                        >
                                            <DialogTitle fontWeight={"bold"}>
                                                Are you sure you want to delete?
                                            </DialogTitle>
                                            <DialogActions>
                                                <Button
                                                    onClick={() => setDeleteConfirmationOpen(false)}
                                                    sx={{
                                                        color: "#5a6a85",
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                                <Button
                                                    onClick={handleDeleteConfirmation}
                                                    color="error"
                                                    autoFocus
                                                >
                                                    Delete
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </>
                                )}
                            </Grid>
                        </Grid>

                        <Grid
                            item
                            xs={12}
                            border={1}
                            p={2}
                            m={3}
                            mb={1}
                            mr={0}
                            borderRadius={1}
                            sx={{ borderColor: "grey.400" }}
                        >
                            <Grid container alignItems="center" mb={2}>
                                <Grid item xs={10}>
                                    <label style={{ color: theme.palette.grey[600] }}>PDC</label>
                                </Grid>
                                <Grid item xs={2} container justifyContent="flex-end">
                                    <Button variant="contained" onClick={handleAddPdc}>
                                        Add Pdc
                                    </Button>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                {data?.pdc.map((val, index) => (
                                    <Grid container spacing={2} key={index} mb={2}>
                                        <Grid item xs={2}>
                                            <TextField
                                                fullWidth
                                                color="primary"
                                                label="Cheque Serials Number"
                                                value={val.chequeSerialNumber}
                                                onChange={(e) =>
                                                    handlePdcChange(
                                                        index,
                                                        "chequeSerialNumber",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <LocalizationProvider
                                                dateAdapter={AdapterDayjs}
                                                color="primary"
                                            >
                                                <DatePicker
                                                    label="Select cheque date "
                                                    name="chequeDate"
                                                    onChange={(date) =>
                                                        handleChangeChequeDate(date, index)
                                                    }
                                                    value={
                                                        data.chequeDate
                                                            ? dayjs(data.chequeDate)
                                                            : null
                                                    }
                                                    format="DD/MM/YYYY"
                                                    sx={{
                                                        width: "100%",
                                                        "& .MuiOutlinedInput-root": {
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: "primary.main",
                                                            },
                                                        },
                                                        "& .MuiInputLabel-root": {
                                                            "&.Mui-focused": {
                                                                color: "primary.main",
                                                            },
                                                        },
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                        {/* <Grid item xs={3}>
                                        <TextField
                                            select
                                            color="primary"
                                            fullWidth
                                            label="Select Bank"
                                            name="bank"
                                            value={val.bank}
                                            onChange={(e) =>
                                                handlePdcChange(index, "bank", e.target.value)
                                            }
                                            required
                                        >
                                            {banks.map((val) => (
                                                <MenuItem key={val.id} value={val.id}>
                                                    {val.name}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid> */}
                                        <Grid item xs={2}>
                                            <Autocomplete
                                                disablePortal
                                                id="combo-box-demo"
                                                options={banks}
                                                getOptionLabel={(option) => option.name}
                                                value={
                                                    val.bank
                                                        ? banks.find((bank) => bank.id === val.bank)
                                                        : null
                                                }
                                                onChange={(event, newValue) =>
                                                    handleBankChange(index, newValue)
                                                }
                                                isOptionEqualToValue={(option, value) =>
                                                    option === value
                                                }
                                                renderOption={(props, option) => (
                                                    <li {...props} key={option.id}>
                                                        {option.name}
                                                    </li>
                                                )}
                                                sx={{
                                                    width: "100%",
                                                    "& .MuiOutlinedInput-root": {
                                                        "&.Mui-focused fieldset": {
                                                            borderColor: "primary.main",
                                                        },
                                                    },
                                                    "& .MuiInputLabel-root": {
                                                        "&.Mui-focused": {
                                                            color: "primary.main",
                                                        },
                                                    },
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        fullWidth
                                                        label="Select bank"
                                                    />
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <TextField
                                                fullWidth
                                                color="primary"
                                                label="Amount"
                                                value={val.amount}
                                                onChange={(e) =>
                                                    handlePdcChange(index, "amount", e.target.value)
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <TextField
                                                select
                                                color="primary"
                                                fullWidth
                                                label="Select Type"
                                                name="type"
                                                value={val.type}
                                                onChange={(e) =>
                                                    handlePdcChange(index, "type", e.target.value)
                                                }
                                            >
                                                <MenuItem value="rent">Rent</MenuItem>
                                                <MenuItem value="deposit">Deposit</MenuItem>
                                            </TextField>
                                        </Grid>
                                        <Grid item xs={1} container justify="end" margin="auto">
                                            <IconButton
                                                color="error"
                                                onClick={() => handleCancelPdc(index)}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                ))}
                            </Grid>

                            {editMode && !renewMode && (
                                <>
                                    <TableContainer
                                        sx={{
                                            overflowX: "auto",
                                            marginBottom: theme.spacing(2),
                                            maxHeight: 900,
                                        }}
                                    >
                                        <Table
                                            stickyHeader
                                            aria-label="sticky table"
                                            sx={{ backgroundColor: "#fff" }}
                                        >
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell
                                                        fontWeight="900"
                                                        sx={{
                                                            backgroundColor:
                                                                theme.palette.background.alt,
                                                            color: "#1a2138",
                                                        }}
                                                    >
                                                        Sr No
                                                    </TableCell>
                                                    <TableCell
                                                        fontWeight="900"
                                                        sx={{
                                                            backgroundColor:
                                                                theme.palette.background.alt,
                                                            color: "#1a2138",
                                                        }}
                                                    >
                                                        Cheque Serials Number
                                                    </TableCell>
                                                    <TableCell
                                                        fontWeight="900"
                                                        sx={{
                                                            backgroundColor:
                                                                theme.palette.background.alt,
                                                            color: "#1a2138",
                                                        }}
                                                    >
                                                        Cheque Date
                                                    </TableCell>
                                                    <TableCell
                                                        fontWeight="900"
                                                        sx={{
                                                            backgroundColor:
                                                                theme.palette.background.alt,
                                                            color: "#1a2138",
                                                        }}
                                                    >
                                                        Bank
                                                    </TableCell>
                                                    <TableCell
                                                        fontWeight="900"
                                                        sx={{
                                                            backgroundColor:
                                                                theme.palette.background.alt,
                                                            color: "#1a2138",
                                                        }}
                                                    >
                                                        Type
                                                    </TableCell>
                                                    <TableCell
                                                        fontWeight="900"
                                                        sx={{
                                                            backgroundColor:
                                                                theme.palette.background.alt,
                                                            color: "#1a2138",
                                                        }}
                                                    >
                                                        Amount
                                                    </TableCell>
                                                    {!isSold && (
                                                        <TableCell
                                                            sx={{
                                                                backgroundColor:
                                                                    theme.palette.background.alt,
                                                                color: "#5a6a85",
                                                            }}
                                                        >
                                                            Action
                                                        </TableCell>
                                                    )}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {pdc.length ? (
                                                    pdc.map((row, index) => (
                                                        <TableRow
                                                            hover
                                                            role="checkbox"
                                                            tabIndex={-1}
                                                            key={row.id}
                                                        >
                                                            <TableCell>{index + 1}</TableCell>
                                                            <TableCell>
                                                                {row.chequeSerialNumber}
                                                            </TableCell>
                                                            <TableCell>
                                                                {row.chequeDate
                                                                    ? moment(row.chequeDate).format(
                                                                          "DD/MM/YYYY"
                                                                      )
                                                                    : "-"}
                                                            </TableCell>
                                                            <TableCell>{row.banks.name}</TableCell>
                                                            <TableCell>
                                                                {row?.type === "rent"
                                                                    ? "Rent"
                                                                    : "Deposit"}
                                                            </TableCell>
                                                            <TableCell>{row.amount}</TableCell>
                                                            {!isSold && (
                                                                <TableCell>
                                                                    <IconButton
                                                                        color="error"
                                                                        onClick={() =>
                                                                            handleDeletePdcClick(
                                                                                row
                                                                            )
                                                                        }
                                                                    >
                                                                        <DeleteIcon />
                                                                    </IconButton>
                                                                </TableCell>
                                                            )}
                                                        </TableRow>
                                                    ))
                                                ) : (
                                                    <TableRow>
                                                        <TableCell
                                                            colSpan={6}
                                                            sx={{
                                                                textAlign: "center",
                                                                fontWeight: "700",
                                                                mb: "2px",
                                                            }}
                                                        >
                                                            No data found
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <Dialog
                                        open={deleteConfirmationPdcOpen}
                                        onClose={() => setDeleteConfirmationPdcOpen(false)}
                                    >
                                        <DialogTitle fontWeight={"bold"}>
                                            Are you sure you want to delete?
                                        </DialogTitle>
                                        <DialogActions>
                                            <Button
                                                onClick={() => setDeleteConfirmationPdcOpen(false)}
                                                sx={{ color: "#5a6a85" }}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                onClick={handleDeleteConfirmationPdc}
                                                color="error"
                                                autoFocus
                                            >
                                                Delete
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                </>
                            )}
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Remarks"
                                variant="outlined"
                                multiline
                                fullWidth
                                color="primary"
                                rows={4}
                                value={data?.remarks}
                                onChange={handleChange}
                                name="remarks"
                            />
                        </Grid>
                        {/* <Grid item xs={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.closed}
                                        onChange={(e) =>
                                            setData({
                                                ...data,
                                                closed: e.target.checked,
                                            })
                                        }
                                        name="closed"
                                        color="primary"
                                    />
                                }
                                label="Closed"
                            />
                        </Grid> */}
                    </Grid>

                    <DialogActions>
                        <Grid container spacing={2} alignItems="center">
                            {/* {editMode && (
                                <Grid item xs={12} sm="auto">
                                    <Button
                                        variant="contained"
                                        onClick={handleOpenReceipt}
                                        sx={{
                                            color: theme.palette.primary.light,
                                            backgroundColor: "green",
                                        }}
                                    >
                                        Add Receipts
                                    </Button>
                                </Grid>
                            )} */}
                            <Grid item xs={12} sm="auto" sx={{ ml: "auto" }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        gap: 2,
                                        justifyContent: { xs: "center", sm: "flex-end" },
                                    }}
                                >
                                    {/* <Button
                                        variant="contained"
                                        onClick={onClose}
                                        sx={{
                                            color: theme.palette.primary,
                                            backgroundColor: theme.palette.primary[800],
                                        }}
                                    >
                                        Cancel
                                    </Button> */}
                                    <Button
                                        variant="contained"
                                        onClick={handleSubmit}
                                        sx={{
                                            color: theme.palette.primary.light,
                                            backgroundColor: theme.palette.secondary[200],
                                        }}
                                    >
                                        {editMode && !renewMode ? "Update" : "Add"}
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </DialogContent>
            </Dialog>

            <Receipt
                open={openReceipt}
                onClose={handleCloseReceipt}
                receiptData={selectedRow}
                receiptOpenMode={!!selectedRow}
            />
        </>
    );
};

export default AddContract;
